import { z } from 'zod'

export const UrlSchema = z.string().url().min(1)

export type Url = z.infer<typeof UrlSchema>

export function validateUrl(url: Url): Url {
  return UrlSchema.parse(url)
}
